import {
  CorpTypeList3,
  formClassCorp,
  OkOrNoFlug,
  YesOrNoFlug,
} from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const stepper = [
  "法人情報",
  "施設情報・職員情報",
  "届出内容確認",
  "機構へ提出",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle: labelids.labelid.LBLC030102_01,
  },
  {
    title: "経営者種別",
    keyword: "businessOwnerClass",
    type: "selectForm",
    selectPropsList: TkGetCodeList(CorpTypeList3),
    helpicon: true,
    helpText: (
      <>
        法人格を選択してください。
        <br />
        詳しくは、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫共済契約者の要件について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご覧ください。
        <br />
      </>
    ),
  },
  {
    title: "法人名（ｶﾅ）",
    keyword: "corpNameKana",
    requiredIcon: true,
    helpicon: true,
    helpText: "法人格を除いて法人名称（フリガナ）を入力してください。",
    convertToHalfwidth: true,
    inputProps: { maxLength: 85 },
  },
  {
    title: "法人名",
    keyword: "corpName",
    requiredIcon: true,
    helpicon: true,
    helpText: "法人格を除いて法人名称を入力してください。",
    explanatoryInTitle: "※法人格は不要です",
    inputProps: { maxLength: 85 },
  },
  {
    title: "代表者職名",
    keyword: "directorTitle",
    requiredIcon: true,
    helpicon: true,
    helpText: "代表者の役職名（理事長、会長等）を入力してください。",
    inputProps: { maxLength: 85 },
  },
  {
    title: "代表者氏名",
    keyword: "directorName",
    requiredIcon: true,
    type: "name",
    helpicon: true,
    helpText: "代表者（理事長、会長等）の氏名を入力してください。",
  },
  {
    title: "郵便番号",
    keyword: "zipcode",
    requiredIcon: true,
    type: "addressSearch",
    helpicon: true,
    helpText:
      "履歴事項全部証明書に記載されている主たる事務所の住所の郵便番号を入力してください。",
    inputProps: { maxLength: 7 },
  },
  {
    title: "所在地",
    keyword: "address",
    type: "locationGroup",
    valueObject: {
      prefectures: "",
      city: "",
      address: "",
    },
    requiredIcon: true,
    helpicon: true,
    helpText: "履歴事項全部証明書に記載されている主たる事務所の住所です。",
    inputProps: { maxLength: 85 },
  },
  {
    title: "法人番号",
    keyword: "corpNo",
    helpicon: true,
    helpText: "日本の国税庁が指定する１３桁の番号を入力してください。",
    inputProps: { maxLength: 13 },
  },
  {
    title: "代表電話番号",
    keyword: "tel",
    requiredIcon: true,
    type: "phoneNum",
  },
  {
    title: "代表FAX番号",
    keyword: "fax",
    type: "phoneNum",
  },
  {
    title: "履歴事項全部証明書",
    keyword: formClassCorp["履歴事項全部証明書（写）"],
    type: "fileUpload",
    helpicon: true,
    helpText: "３カ月以内に発行されたものを添付してください。",
    requiredIcon: true,
    id: "1",
  },
  {
    title: "就業規則",
    keyword: formClassCorp["就業規則"],
    type: "fileUpload",
    helpicon: true,
    helpText: "法人就業規則一式を登録してください。",
    requiredIcon: true,
    id: "2",
  },
  {
    title: "給与規程",
    keyword: formClassCorp["給与規程"],
    type: "fileUpload",
    helpicon: true,
    helpText:
      "法人の給与規程一式を登録してください。※基本給（格付）俸給表も含みます。",
    requiredIcon: true,
    id: "3",
  },
  {
    keyword: "title2",
    type: "lineTitle",
    lineTitle: labelids.labelid.LBLC030102_02,
  },
  {
    title: "所属部署名",
    keyword: "managerDeptName",
    requiredIcon: true,
    helpicon: true,
    helpText:
      "共済契約申込み手続きを行うご担当者の所属部署名を入力してください。",
    inputProps: { maxLength: 85 },
  },
  {
    title: "役職",
    keyword: "managerPosition",
    requiredIcon: true,
    helpicon: true,
    helpText: "共済契約申込み手続きを行うご担当者の役職を入力してください。",
    inputProps: { maxLength: 85 },
  },
  {
    title: "氏名",
    keyword: "managerName",
    type: "name",
    requiredIcon: true,
  },
  {
    title: "電話番号",
    keyword: "managerTel",
    type: "phoneNum",
    requiredIcon: true,
    helpicon: true,
    helpText:
      "共済契約申込み手続きを行うご担当者の連絡先電話番号を入力してください。",
  },
  {
    title: "連絡先メールアドレス",
    keyword: "managerEmail",
    type: "mail",
    requiredIcon: true,
    helpicon: true,
    helpText: (
      <>
        共済契約申込み手続きを行ううえでの連絡先メールアドレスを入力してください。
        <br />
        ※今後、当該メールアドレスに機構からの各種連絡が届くため、ご担当者の方とご担当者以外の方も確認できるメールアドレスを登録してください。
      </>
    ),
    inputProps: { maxLength: 85 },
  },
  {
    keyword: "title3",
    type: "lineTitle",
    lineTitle: "本共済契約の契約希望日を入力してください",
  },
  {
    title: "契約希望日",
    keyword: "applyDate",
    type: "date",
    helpicon: true,
    helpText:
      "契約希望日は、申込時期等によりご希望に添えない場合がございます。なお、機構が申込書を審査した結果、適格と認められたときは、その申込日において成立したものとみなし、かつ、その日から効力を生じます。",
    disabled: true,
  },
  {
    keyword: "title4",
    type: "lineTitle",
    lineTitle: "申込み前提事項の確認",
  },
  {
    title: "過去に退職手当共済契約を締結したことはありますか？",
    keyword: "pastContractFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(OkOrNoFlug),
    requiredIcon: true,
    helpicon: true,
    helpText:
      "過去に退職共済契約を締結していたことがあれば、「はい」、無ければ「いいえ」を選択してください。",
  },
  {
    title: "契約解除日",
    keyword: "pastContractCancelDate",
    type: "date",
    showLine: false,
  },
  {
    title: "現在、中小企業退職手当共済契約を締結されていますか？",
    keyword: "smeRmaFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(OkOrNoFlug),
    helpicon: true,
    helpText:
      "現在中小企業退職手当共済契約を締結していれば、「はい」、無ければ「いいえ」を選択してください。",
  },
  {
    title: "給与の支払い遅滞の有無",
    keyword: "payrollDeferredFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    requiredIcon: true,
    helpicon: true,
    helpText: "給与支払い遅滞が無ければ、✓を入れてください。",
  },
  {
    keyword: "lineTitleCyouSei",
    type: "lineTitle",
    lineTitle: (
      <h1 className="guide">調整のため、機構にお問い合わせください。</h1>
    ),
    showLine: false,
  },
  {
    keyword: "lineTitleImportant",
    type: "lineTitle",
    lineTitle: "重要事項説明書を確認のうえ内容に対して同意してください。",
    showLine: true,
  },
  {
    keyword: "nodeButtonImportant",
    type: "node",
    node: null,
    showLine: true,
  },
  {
    keyword: "lineTitleImportantConfirm",
    type: "lineTitle",
    lineTitle:
      "間違いが無いことを確認出来ましたら、「確認」ボタンを押して施設情報の登録に進んでください。",
    showLine: true,
  },
];

const schema = {
  corpNameKana: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[ｧ-ﾝｦﾞﾟ\s-]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0054E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  corpName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  directorTitle: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  directorName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  zipcode: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    minLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
  },
  pastContractFlg: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  payrollDeferredFlg: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  address: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    validate: (data: any) => {
      const errorCheckers = {
        prefectures: (value: string) => {
          if (!value) return TkPropertyMessageGet("TKMSG_SCR0043E");
          return "";
        },
        city: (value: string) => {
          if (!value) return TkPropertyMessageGet("TKMSG_SCR0043E");
          if (value.length > 20)
            return TkPropertyMessageGet("TKMSG_SCR0046E", "20");
          // eslint-disable-next-line no-control-regex
          if (!value.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/))
            return TkPropertyMessageGet("TKMSG_SCR0061E");
          return "";
        },
        address: (value: string) => {
          if (!value) return TkPropertyMessageGet("TKMSG_SCR0043E");
          if (value.length > 85)
            return TkPropertyMessageGet("TKMSG_SCR0046E", "85");
          // eslint-disable-next-line no-control-regex
          if (!value.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/))
            return TkPropertyMessageGet("TKMSG_SCR0061E");
          return "";
        },
      };

      let error = {
        prefectures: errorCheckers.prefectures(data.prefectures),
        city: errorCheckers.city(data.city),
        address: errorCheckers.address(data.address),
      };

      if (Object.values(error).every((value) => !value)) {
        return true;
      }

      return JSON.stringify(error);
    },
  },
  corpNo: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 13,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "13"),
    },
    minLength: {
      value: 13,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "13"),
    },
  },
  tel: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
  },
  fax: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
  },
  [formClassCorp["履歴事項全部証明書（写）"]]: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  [formClassCorp["就業規則"]]: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  [formClassCorp["給与規程"]]: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  managerDeptName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  managerPosition: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  managerName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  managerTel: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
  },
  managerEmail: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
};

export { stepper, fakeTableList, schema };
